module.exports = __webpack_public_path__ + "img/joy.ea27aa00.gif";